import React from "react";

import styled from "styled-components";

import { color } from "../../tokens";
import { Icon } from "../Icon/Icon";
import { Select } from "../Select/Select";
import { Typography } from "../Typography/Typography";
import { usePaginator } from "./usePaginator";

interface Props {
  translate: (i18nKey: string, args?: Record<string, any>) => string;
  page: number;
  pageSize?: number;
  pageSizes?: number[];
  count: number;
  onChange: ({ page, pageSize }: { page: number; pageSize: number }) => void;
}

export const Paginator: React.FC<Props> = (props) => {
  const { translate, count } = props;
  const {
    pageOption,
    pageSizeOptions,
    start,
    end,
    canInc,
    canDec,
    inc,
    dec,
    setPageSize,
  } = usePaginator(props);

  return (
    <Wrapper>
      <Typography variant="bodySmall" color={color.neutral[500]}>
        {translate("paginatorRowsPerPage", { namespace: "DEFAULT" })}
      </Typography>

      <SelectWrapper>
        <Select<number>
          options={[{ label: "", options: pageSizeOptions }]}
          selectedOption={pageOption}
          onChange={(option) => option && setPageSize(option.value)}
        />
      </SelectWrapper>

      <InfoWrapper>
        <Typography variant="bodySmall" color={color.neutral[500]} noSelect>
          {translate("paginatorRange", {
            namespace: "DEFAULT",
            start,
            end,
            total: count.toLocaleString(),
          })}
        </Typography>
      </InfoWrapper>

      <Icon
        button
        onClick={dec}
        icon="chevronLeft"
        size="xs"
        disabled={!canDec}
        color={color.blue[400]}
      />
      <Icon
        button
        onClick={inc}
        icon="chevronRight"
        size="xs"
        disabled={!canInc}
        color={color.blue[400]}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 0.5rem;
`;

const SelectWrapper = styled.div`
  width: 8rem;
`;

const InfoWrapper = styled.div`
  min-width: 9rem;
  text-align: right;
`;
